
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './branding.json';

const Branding = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Marketing, brand identity, and consumer psychology vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Branding"
            image="/Images/Iconic_Logos.webp"
            seoTitle="Free English Lesson Plans: Branding"
            seoDescription="Marketing, brand identity, and consumer psychology vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Branding;


